import React from "react";
import { INotification } from "../../../providers/NotificationProvider";
import { useNavigate } from "react-router-dom";
import { formatDateUTCBr } from "@utils";

const NotificationUrgentAlertItem = (props: INotification) => {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate("/routing/map/trips", { state: { tripId: props.tripId } });
  };

  return (
    <div className="padding-y-15 padding-x-25 width-100pct cursor-pointer hover-bg-light" onClick={handleRedirect}>
      <div>
        <span className="text-size-12 text-color-dark text-bold line-height-20">Alerta</span>
      </div>

      <div className="display-flex align-items-start gap-15 padding-y-10">
        <div className="bg-danger width-40 height-40 display-flex align-items-center justify-content-center rounded-circle padding-bottom-5">
          <span className="rioglyph rioglyph-warning-sign text-size-h4 text-color-white margin-top-4" />
        </div>

        <div className="flex-grow-1 overflow-hidden">
          <div className="display-flex gap-10 align-items-center">
            <span className="text-bold text-size-14 ">
              {props.driverName} • <span className="text-color-danger"> Alerta urgente</span>
            </span>
          </div>

          <div className="display-flex gap-4 align-items-start margin-top-8">
            <span className="text-size-12 line-height-20 text-normal  word-break-word">
              O motorista indicou um alerta urgente em sua viagem.
            </span>
          </div>

          <div className="display-flex align-items-center gap-10 margin-top-8">
            <div className="display-flex gap-4 align-items-start">
              <span className="rioglyph rioglyph-calendar text-size-12  flex-shrink-0 margin-top-2 text-color-gray" />
              <span className="text-size-12 line-height-20 text-normal">{formatDateUTCBr(props.createdAt)}</span>
            </div>

            <span className="text-color-gray">•</span>

            <div className="display-flex gap-4 align-items-start">
              <span className="rioglyph rioglyph-finish text-size-14 text-color-gray"></span>
              <span className="text-size-12 line-height-20 text-normal">{props.destinyName}</span>
            </div>

            <span className="text-color-gray">•</span>

            <div className="display-flex gap-4 align-items-start">
              <span className="rioglyph rioglyph-truck text-size-12  flex-shrink-0 margin-top-2 text-color-gray" />
              <span className="text-size-12 line-height-20 text-normal">{props.assetName}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotificationUrgentAlertItem;
